// 工单权益
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div  class="grid-height"  style="height: calc(100vh - -75px);">
          <vxe-grid show-overflow border="default"  height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
          >

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="rightsOffBillExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;"
                              class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form  ref="form" class="screen-box" title-width="7vw"
                          title-align="right" :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent" >

                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo"  style="width: 16vw!important;"  clearable/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="服务商:" field="name">
                    <template v-slot>
                      <el-autocomplete
                        class="inline-input"
                        style="width: 16vw!important;"
                        v-model="formData.siteName"
                        :fetch-suggestions="querySiteSearch"
                        placeholder="请输入内容"
                        :trigger-on-focus="false"
                        @select="handleSiteSelect" clearable
                      ></el-autocomplete>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name" >
                    <template v-slot style=" display: inline-block;">
                      <el-date-picker  v-model="formData.createTime" type="daterange" align="right" unlink-panels
                      style="width: 16vw!important;"
                                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="完工时间:" field="name" >
                    <template v-slot style=" display: inline-block;">
                      <el-date-picker  v-model="formData.completeTime" type="daterange" align="right" unlink-panels
                                       style="width: 16vw!important;"
                                       range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                                       :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </el-collapse-transition>


              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
											btnGoodsStatusBt1: goodsStatusIndex == index,
											btnGoodsStatusBt: goodsStatusIndex != index
										}" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span v-if="item.name!='所有'" class="num_color">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
            <template #option="{row}">
              <div>
                <el-dropdown @command="handleCommand($event, row)" >
                  <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import store from "@/store";
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import api from "@/api/projectApi";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";


export default {
  name: 'pool',

  inject: ['reload'],
  components: {detailsDialog, editView, pager,
    ServiceTypeCascader},
  data() {
    return {
      isShowSettle: true,
      total: 0,
      searchValue: null,
      showPage: true,
      showCloseDialog: false,
      intoSettlePoolButton: false,
      settleRetryServiceFeeButton: false,
      suspensionSettlement: false,
      showDetailsDialog: false,
      rightsOffBillExport: false,
      longDisAmountImport: false,
      excelUpload: false,
      requestParam: {
        stat: null,
        orderNo: null,
        siteId: null,
        fuzzySearchIsEnable: false,
        fuzzySearchValue: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        tabStat:'生成',
      },

      formData: {
        stat: null,
        orderNo: null,
        siteId: null,
        createTime: null,
        createTimeBegin: null,
        createTimeEnd: null,
        completeTime: null,
        completeTimeBegin: null,
        completeTimeEnd: null,
        siteName: null,
      },
      show3: false,

      sitePromptList: [],

      goodsStatusList: [ //循环列表
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: '',
      value3: '',
      value: '',
      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      // 查询参数


      pageSizes: [10, 20, 100],

      showEdit: false,

      columns: [
        {type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left'},
        {
          width: 60,
          field: 'status',
          fixed: 'right',
          title: '操作',
          showOverflow: true,
          slots: {
            default: 'option'

          }
        },
        { title: '核销单号', field: 'billNo', width: 150, },
        // { title: '工单号', field: 'orderNo', width: 190,},
        {
          title: '工单号', field: 'orderNo', width: 190, slots: {
            default: ({row}) => {
              return [
                <span style="color: blue; cursor: pointer"
                      onClick={($event) => this.addressClickEvent(row, $event)}>{row.orderNo}</span>
              ]
            }
          }
        },
        // { title: '网点名称', field: 'siteName', width: 100, },
        { title: '状态', field: 'stat', width: 125, slots: {
            default: ({row}) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status disable">
                    <span>生成</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status ">
                    <span>待结算</span>
                  </div>
                ];
              }else if (row.stat == 9) {
                return [
                  <div class="txt-status ">
                    <span>已结算</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status ">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },

        // { title: '结算单号', field: 'settleNo', width: 190, slots: {
        //   }
        // },
        { title: '权益名称', field: 'rightsName', width: 150, },
        { title: '结算单号', field: 'batchNo', width: 150, },
        { title: '结算金额', field: 'amount', width: 150, },
        { title: '费用网点', field: 'bigSiteName', width: 150, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '服务中心',field: 'orgName', width: 100,},
      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    'formData.siteName': {
      handler(newVal) {
        if (!newVal) {
          this.formData.siteId = null
        }
      },
      deep: true
    },
    'formData.createTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    'formData.completeTime': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.completeTimeBegin = newVal[0]
          this.formData.completeTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.completeTimeBegin = null
          this.formData.completeTimeEnd = null
        }
      },
      deep: true,
    },
  },
  created() {
    this.rightsOffBillExport = this.permissions["rightsOffBillExport"];//导出
  },

  mounted() {
    //this.loadTabOption()
    this.initSearchDate()
  },

  methods: {

    refreshChange() {
      this.getTableData()
    },

    //导出
    doExcle(){
      this.$mask.open()
      this.$objCopy(this.formData, this.requestParam)
      doCheckExcle(fileNames.sfRightsOffBill).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.sfRightsOffBill.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },

    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },
    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },
    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showCloseDialog = false
      // this.flushed()
    },
    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.createTime = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    this.loadTabOption()

    },
    openInfoDialog(row, $event) {
      this.showSave = false
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },


    // 加载tab数据
    loadTabOption() {
      this.$http({
        url: api.sfRightsOffBill.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
      })
    },


    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.sfRightsOffBill.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比

      console.log('goodsStatusItem', this.goodsStatusItem)
      this.requestParam.tabStat = this.goodsStatusItem
      this.enableStat = item.name === '所有'

      this.getTableData()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        feeType: '',
        name: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.feeType = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },



    // 选中的按钮
    addressClickEvent(row) {
      console.log(row, 'row')
      this.dataId = row.orderId
      this.showDetailsDialog = true
      // this.openEditDialog(row.id);
      // console.log(row, id, "row");
    },
    // 打开操作弹窗
    handleCommand(b,row) {
      if (b == 1) {
        this.dataId = row.id
        this.cancelSettle()
      } else if (b == 2) {
        this.open()
      }else if (b == 3) {
        this.intoSettlePool(row.orderNo)
      }
    },

    // 打开执行考核弹窗
    handleCommand2(command, b) {
      console.log(command, b, "command,b的值");
      this.$message('click on item ' + b);
      if (b == 1) {
        this.showPreconditionDialog2 = true;
      } else if (b == 2) {
        this.open()
      }
    },

    optionChange(value, target) {
      console.log(111, "11111111");
      console.log(value);
      // var select = document.querySelectorAll(".status_select");
      console.log('接受的option的值1', target)
      // var grade = select.options[select.selectedIndex].value;
      // alert(grade);
      // console.log(grade, "grade的值");
      if (target == 2) {

        this.open()


      }


    },


    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    // 新增
    openEditDialog(id) {

      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },


  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}
::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
}
</style>
